import type { DayRecord } from '../hooks/useDailyWord';
import { formatDayLong } from '../lib/dates';
import styles from './TheBook.module.css';

interface TheBookProps {
  history: DayRecord[];
  onBack: () => void;
}

export function TheBook({ history, onBack }: TheBookProps) {
  if (history.length === 0) {
    return (
      <section className={styles.empty}>
        <h2 className={styles.title}>the book</h2>
        <p className={styles.body}>
          when you choose a word and reflect on it, those days collect here.
          come back tomorrow.
        </p>
        <button type="button" className={styles.back} onClick={onBack}>
          ← back to today
        </button>
      </section>
    );
  }

  return (
    <section className={styles.frame}>
      <header className={styles.header}>
        <h2 className={styles.title}>the book</h2>
        <button type="button" className={styles.back} onClick={onBack}>
          ← back to today
        </button>
      </header>

      <ol className={styles.list} reversed>
        {history.map((record) => (
          <li key={record.date} className={styles.entry}>
            <p className={styles.date}>{formatDayLong(record.date)}</p>
            <p className={styles.word}>{record.word}</p>
            {record.reflection ? (
              <p className={styles.reflection}>{record.reflection}</p>
            ) : (
              <p className={styles.noReflection}>(no reflection)</p>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
